import { toast } from '@systemeio/ui'
import { ErrorResponseContentInterface } from '@systemeio/util'
import React from 'react'

export const handleOfferPricePlansErrors = (
  errors: ErrorResponseContentInterface<{
    offerPricePlans?: string[]
    bumps?: [{ offerPricePlans?: string[] }] | [[string]]
  }>,
) => {
  const getErrorMessage = () => {
    const { offerPricePlans, bumps } = errors.fields

    if (offerPricePlans) return offerPricePlans

    const firstElement = bumps?.[0]
    if (firstElement) {
      return Array.isArray(firstElement) ? firstElement : firstElement.offerPricePlans
    }
  }

  const errorMessage = getErrorMessage()?.join(', ')

  if (!errorMessage) return

  toast.error(
    <span className={'[&>a]:!primary-link'} dangerouslySetInnerHTML={{ __html: errorMessage }} />,
  )
}
